import { render, staticRenderFns } from "./CommonSettingsPart.vue?vue&type=template&id=263d0f0e"
import script from "./CommonSettingsPart.vue?vue&type=script&lang=js"
export * from "./CommonSettingsPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports